import type { FetchResult } from '@apollo/client';

import { IMigrateRisk } from '../models/models';
import { DeficiencyList } from '../rxdb/deficiencyList/queryBuilder';
import { client, gql } from './Client';

interface IDeficiencyMutation {
  migrationDeficiencyData: DeficiencyList;
}

interface IRiskMutation {
  migrationDeficiencyRiskData: boolean;
}

const deficiencyMutation = gql`
  mutation migrationDeficiencyData(
    $role: Int!
    $MobileInspectionDeficienciesListFeedInput: MobileInspectionDeficienciesListFeedInput
  ) {
    migrationDeficiencyData(role: $role, deficiency: $MobileInspectionDeficienciesListFeedInput) {
      pkDeficiencyUUID
      repairFactorId
      componentFailureId
      isCompletedDuringInspection
      componentType
      causeOfFailure
      remedialAction
      remedialActionId
      commentRemedialAction
      assetCategoryComponentId
      commentAssetComponent
      assetInspectionId
      failureCauseCategory
      areaId
      fkAsset
      fkArea
      pcsId
      isActive
      isAdhoc
      locationDescription
      commentObservation
      name
      dateObserved
      site
      discipline
      dateCreated
      dateModified
      isDelete
      fieldInspectorId
      leadInspectorId
      inspectionTaskId
      commentSiteCoordinator
      commentInspectorLead
      commentInspectorField
      attentionFlag
      taskStatusCategory
      fkComponent
      lowerElevation
      isReInspectedComponent
      upperElevation
      componentVersionId
      inspectorOperationalDowntime
      inspectorConditionRating
      inspectorUrgency
      inspectorTrafficScore
      componentVersionInspectionId
      componentVersionUUID
      componentAreaInfo {
        componentFailureId
        areaId
        areaPcsId
        inspectionId
        trafficSafety
        componentVersionId
      }
    }
  }
`;

const riskMutation = gql`
  mutation migrationDeficiencyRiskData($MigrationRiskDataInput: MigrationRiskDataInput) {
    migrationDeficiencyRiskData(riskDataInput: $MigrationRiskDataInput)
  }
`;

const migrateDeficiency = (
  MobileInspectionDeficienciesListFeedInput: DeficiencyList,
): Promise<FetchResult<IDeficiencyMutation>> =>
  client.mutate({
    mutation: deficiencyMutation,
    variables: { MobileInspectionDeficienciesListFeedInput, role: 7 },
  });

const migrateRisk = (MigrationRiskDataInput: IMigrateRisk): Promise<FetchResult<IRiskMutation>> =>
  client.mutate({
    mutation: riskMutation,
    variables: { MigrationRiskDataInput },
  });

export { migrateDeficiency, migrateRisk };
